<template>
<div id="dashboard">
    <navbar>
        <template v-slot:nav-items>
        <li class="nav-item">
            <a class="nav-link">
            <i class="fa fa-home" aria-hidden="true"></i>
            Dashboard
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link">
            <i class="fa fa-user" aria-hidden="true"></i>
            Account Settings
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" @click="logout">
            <i class="fa fa-sign-out-alt" aria-hidden="true"></i>
            Logout
            </a>
        </li>
        <li class="nav-item">
            <hr>
        </li>
        <li class="nav-item">
            <a class="nav-link btn btn-topbar ml-2">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Create New Scan
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link btn btn-topbar ml-2">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Generate Risk Report
            </a>
        </li>
        </template>
    </navbar>
    <div id="tab-container">
        <div class="tab-overlay" v-if="!collapse" @click="tapOpen"></div>
        <div
            v-if="isSidebarVisible"
            class="tab-selection"
            :class="{'collapse': collapse, 'in-progress': !isProgressCompleted}"
            id="tab-selection"
            :style="xOffset"
            >
            <div class="scan-info">
                <div class="header">{{scan.label}}</div>
                <div class="subheader">
                    Revision {{scan.revision}}
                    <span class="nav-item mr-5">
                        l {{scan.report_date | niceDate}}
                    </span>
                </div>
            </div>
            <div class="report-tab-container report-menu-container">
                <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
                <div class="tab-title" :key="index" v-for="(tab, index) in tabs"
                    :class="{'selected': tab.component === selected_tab}">
                    {{tab.name}}
                    <div class="badge badge-primary badge-sm" v-if="tab.isBetaVersion">BETA</div>
                </div>
            </div>
            <div class="report-tab-container">
                <div class="header">ACTIONS</div>
                <div class="tab-title">
                    <a class="action-link">Rescan</a>
                </div>
                <div class="tab-title">
                    <a class="action-link">Send to Jira</a>
                </div>
            </div>
            <div class="report-tab-container integrations-container">
                <div class="header">INTEGRATIONS</div>
                <div class="icons-container">
                    <img src="/assets/images/app-icon-256.png" />
                    <img
                        v-if="useQualys"
                        class="qualys-icon"
                        src="/assets/images/qualys-logo.png"
                    />
                </div>
            </div>
            <div class="report-tab-container download-btn-container">
                <div class="header">DOWNLOADS</div>
                <div class="sub-header">Download Report</div>
                <div class="buttons">
                    <button class="btn btn-block download-btn" title="Download full Excel report"
                        id="download-report">
                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                        xlsx
                    </button>
                    <button class="btn btn-block download-btn" title="Download zipped CSV report"
                        id="download-report">
                        <font-awesome-icon :icon="['fas', 'file-csv']" />
                        csv
                    </button>
                </div>
            </div>
        </div>
        <div v-if="collapse" id="tab-open" class="tab-collapsed" @click="tapOpen"><i class="fa fa-chevron-right"></i></div>
        <div class="component-wrapper" :class="{'full-width': !isSidebarVisible}" ref="component_wrapper">
            <cyber-fitness
                :scanId="'9cbe5e67-f45e-453c-a3c2-89943c7f83a1'"
                :hasAccessToJira="true"
            />
        </div>
    </div>
</div>
</template>

<script>
// eslint-disable-next-line import/extensions
import '~/assets/js/global.js';
import ZingTouch from 'zingtouch';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFileCsv, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Navbar from '~/components/shared/templates/navbar.vue';

import CyberFitness from './cyber-fitness.vue';

library.add(faFileCsv);
library.add(faFileExcel);

export default {
    components: {
        CyberFitness,
        FontAwesomeIcon,
        Navbar,
    },
    data() {
        return {
            tabs: [
                { name: 'Cyber Fitness', component: 'cyber-fitness', isBetaVersion: true },
                { name: 'Report Overview', component: 'overview', isBetaVersion: false },
                { name: 'Issue Details', component: 'issue-details', isBetaVersion: false },
                { name: 'Service Details', component: 'service-details', isBetaVersion: false },
                { name: 'Industry Comparison', component: 'industry-comparison', isBetaVersion: false },
                { name: 'Scan History', component: 'progress-tab', isBetaVersion: false },
                { name: 'Mitigation', component: 'mitigation', isBetaVersion: false },
                { name: '', component: 'scan-progress', isBetaVersion: false },
            ],
            selected_tab: 'cyber-fitness',
            zt: null,
            collapse: true,
            pan: -250,
            scan: {
                label: 'Example',
                report_date: 1625127086,
                unpublished: false,
                revision: 3,
                id: 'ac10ac53-186b-463b-a9f0-cd91ab16db67',
                started: 0,
                download_files_availibility: {
                    xlsx: true,
                    csv: true,
                    json: true,
                },
                canceled: 0,
            },
            host_info_data: {
                host: null,
                sourcePage: null,
            },
            modalState: {
                scanning: false,
                invalid: false,
                jira_report: false,
                jira_host_issues: false,
                jira_issue_hosts: false,
                jira_return_success: false,
                jira_return_fail: false,
            },
            invalidTitle: '',
            invalidMessage: '',
            hasHistory: false,
            showHelpButton: true,
            scan_progress: {},
            hasAccessToJira: false,
            selectedHost: '',
            selectedIssue: '',
            isSidebarVisible: true,
            integrations: {},
        };
    },
    computed: {
        isProgressCompleted() {
            return true;
        },
        xOffset() {
            if (!this.pan) {
                return '';
            }
            return `transform: translateX(${this.pan}px);`;
        },
        useQualys() {
            return this.integrations && 'qualys' in this.integrations;
        },
    },
    mounted() {
        if (window.innerWidth < 992) {
            this.initSwipe();
            this.showHelpButton = false;
        } else {
            this.pan = 0;
            this.collapse = false;
        }
    },
    methods: {
        tapOpen() {
            if (this.pan > -1) {
                this.pan = -250;
            } else {
                this.pan = 0;
            }
            this.collapse = !this.collapse;
        },
        // eslint-disable-next-line no-unused-vars
        selectTab(tab) {
            this.selected_tab = 'cyber-fitness';
        },
        // enables swiping behavior if the user is on mobile (screen size < 992)
        initSwipe() {
            const self = this;
            this.zt = new ZingTouch.Region(document.body);
            // eslint-disable-next-line no-unused-vars
            const container = document.getElementById('tab-container');
            const zingPan = new ZingTouch.Pan({
                numInputs: 1,
                threshold: 10,
            });

            // eslint-disable-next-line no-unused-vars
            zingPan.end = (inputs) => {
                if (self.pan < -30) {
                    self.collapse = true;
                    self.pan = -250;
                }
                return null;
            };

            // var ztTabEl = document.getElementById(document.body);
            // var ztTab = new ZingTouch.Region(ztTabEl, true, false);

            // eslint-disable-next-line no-unused-vars
            // this.tabs.forEach((tab, i) => {
            //     if (tab.component !== '') {
            //         const el = document.getElementById(tab.component);
            //         self.zt.bind(el, 'tap', () => {
            //             self.selected_tab = tab.component;
            //             self.collapse = true;
            //             self.pan = -250;
            //         });
            //     }
            // });

            const ztTapOpenEl = document.getElementById('tab-open');
            // eslint-disable-next-line no-unused-vars
            const ztTapOpenRegion = new ZingTouch.Region(ztTapOpenEl, true, false);
            // eslint-disable-next-line no-unused-vars
            const ztTapOpen = new ZingTouch.Tap({
                maxDelay: 1000,
            });
        },
        prompt(method) {
            this.updateModal({
                key: method,
                state: true,
            });
        },
        toggleSidebarVisibility(value) {
            this.isSidebarVisible = value;
        },
        getScanIntegrations() {
            this.integrations = null;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'global/default';
@import '~/scss/pages/signup.scss';
</style>
